import dayjs from "dayjs";

/**
 * A date as the calendar day the person picked - "YYYY-MM-DD" in their own
 * timezone - for sending as a date-range bound.
 *
 * Ranges used to be sent as Date objects, which travel as UTC timestamps. For
 * anyone ahead of UTC (India, Pakistan) the last day of a month became
 * "2026-10-30T18:30:00.000Z", and since bookings are stored as "2026-10-31",
 * a booking on the last day of a month fell outside that month - and outside
 * the next one too. It vanished from the trackers, client list and calendar
 * list until the month changed.
 */
export const calendarDay = (value) => {
  if (value === null || value === undefined || value === "") return value;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const day = dayjs(value);
  return day.isValid() ? day.format("YYYY-MM-DD") : value;
};
